import { RestrictionWarningComponent } from './restriction-warning.component';

export default angular
  .module('sfMobile.components.restriction-warning', [])
  .component('sfRestrictionWarning', RestrictionWarningComponent).name;
